import { useEffect, useRef, useState } from "react";
import { useIsMobile, useIsTablet } from "./useDeviceType";
import { useLocation } from "react-router-dom";
import { BEBOP_ROUTES } from "config/consts";

export const useToggleIntercom = () => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const isHomePage = useLocation().pathname === BEBOP_ROUTES.Home;
  const tries = useRef<number>(0);
  const [isIntercomInstalled, setIsIntercomInstalled] = useState(false);

  useEffect(() => {
    // Check repeatedly if Intercom has been injected in window object by GTM
    const checkIntercom = () => {
      tries.current += 1;
      if ("Intercom" in window) {
        setIsIntercomInstalled(true);
        return;
      }
      if (tries.current >= 1000) return;
      requestAnimationFrame(checkIntercom);
    };
    checkIntercom();
  }, []);

  // Hide Intercom that shows on default in mobile, as it should appear in the
  // More screen from the mobile navbar
  useEffect(() => {
    if (!isIntercomInstalled) return;
    // Special case for hiding Intercom button on tablet view on home page
    // Since navbar links are hidden from tablet width and below
    const isOnHomePageSideNavTablet = isTablet && isHomePage;
    toggleIntercom(isMobile || isOnHomePageSideNavTablet);
  }, [isHomePage, isIntercomInstalled, isMobile, isTablet]);
};

// Helpers

function toggleIntercom(toHide: boolean) {
  const windowWithIntercom = window as typeof window & {
    Intercom: (...args: Array<unknown>) => void;
  };

  if (windowWithIntercom.Intercom == null) {
    console.warn("Intercom not injected into app.");
    return;
  }

  windowWithIntercom.Intercom("update", {
    hide_default_launcher: toHide,
  });
}

export function showIntercom() {
  const windowWithIntercom = window as typeof window & {
    Intercom: (...args: Array<unknown>) => void;
  };
  if (windowWithIntercom.Intercom == null) {
    console.warn("Intercom not injected into app.");
    return;
  }
  windowWithIntercom.Intercom("show");
}
